module.exports = __webpack_public_path__ + "static/img/h-05.510db5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-05.jpg
// module id = KyNp
// module chunks = 1